import styled from "styled-components";
import { Colors } from "@smartsuite/types";

export const Container = styled.div<{ color: string }>`
  background-color: ${(props) => props.color};
  border-radius: 4px;
  height: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 15px;
`;

export const RightContainer = styled.div`
  display: flex;
  position: absolute;
  right: 16px;
  top: 6.5px;
`;

export const Pipe = styled.div`
  margin: 0.5px 2px;
  border: 0.5px solid ${Colors.custom1}4d;
`;

export const RetryContainer = styled.div`
  padding: 2px 2px 0px 2px;

  right: 16px;
  cursor: pointer;

  height: 20px;
  border-radius: 2px;

  &:hover {
    background: ${Colors.custom2}33;
  }
`;
